import { Button, Text, useDisclosure } from '@chakra-ui/react';
import AppCard from 'presentation/components/shared/card/AppCard';
import RequestServiceManagerCallModal from 'presentation/containers/modules/services/RequestServiceManagerCallModal';
import { Color } from 'presentation/theme/colorScheme';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRequestServiceProductMutation } from 'rtkQuery/sharespro/queries/services';

interface ServiceModalData {
  serviceId: number;
  title: string;
  text: string;
}

interface Props {
  productId: number;
  productName: string;
}

const ServiceProductApplyCard: FC<Props> = ({ productId, productName }) => {
  const { t } = useTranslation();

  const {
    isOpen: isServiceManagerCallOpen,
    onClose: onServiceManagerCallClose,
    onOpen: onServiceManagerCallOpen,
  } = useDisclosure();

  const [serviceModalData, setServiceModalData] =
    useState<ServiceModalData | null>(null);

  const [requestServiceProduct] = useRequestServiceProductMutation();

  return (
    <AppCard p="20px">
      <Text mb="15px" fontSize="md" color="gray.600">
        {t('requestCallManagerProductText')}
      </Text>
      <Button
        w="full"
        size="lg"
        colorScheme="green"
        bg={Color.Primary500}
        color={Color.OnPrimary}
        _hover={{ bg: Color.Primary600 }}
        onClick={() => {
          setServiceModalData({
            serviceId: productId,
            title: productName,
            text: t('requestCallManagerProductText'),
          });
          onServiceManagerCallOpen();
        }}
      >
        {t('leaveRequest')}
      </Button>

      {serviceModalData && (
        <RequestServiceManagerCallModal
          text={serviceModalData.text}
          title={serviceModalData.title}
          isOpen={isServiceManagerCallOpen}
          onClose={onServiceManagerCallClose}
          serviceId={serviceModalData.serviceId}
          onSubmit={async (id) => await requestServiceProduct(+id).unwrap()}
        />
      )}
    </AppCard>
  );
};

export default ServiceProductApplyCard;
